// Shape journal.json entries for display (one consistent image list, a
// readable date, newest first) plus the small helpers the Studio uses to
// write new ones.
export const TYPES = [
  { key: "all", label: "Everything" },
  { key: "thought", label: "Thoughts" },
  { key: "quote", label: "Quotes" },
  { key: "photo", label: "Photos" },
  { key: "video", label: "Videos" },
  { key: "link", label: "Links" },
];

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// "2026-10-12" → "Oct 12, 2026", "2023-01" → "Jan 2023", "2018" → "2018"
export const fmtEntryDate = (date) => {
  if (!date) return "";
  const [y, m, d] = String(date).split("-");
  if (!m) return y;
  if (!d) return `${MONTHS[+m - 1]} ${y}`;
  return `${MONTHS[+m - 1]} ${+d}, ${y}`;
};

export const normalize = (e) => {
  const images = e.images
    ? e.images.map((im) => (typeof im === "string" ? { src: im } : im))
    : e.src
    ? [{ src: e.src, caption: e.caption }]
    : [];
  return { ...e, images, dateLabel: fmtEntryDate(e.date), tags: e.tags || [] };
};

export const prepare = (json) =>
  ((json && json.entries) || [])
    .filter((e) => e && e.type && e.id)
    .map(normalize)
    .sort(
      (a, b) =>
        (b.pinned ? 1 : 0) - (a.pinned ? 1 : 0) || String(b.date || "").localeCompare(String(a.date || ""))
    );

export const hostOf = (url) => {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
};

// ---- writing entries (kept in sync with scripts/post.js) ----

export const todayIso = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const slugify = (s, words = 6) =>
  String(s || "")
    .toLowerCase()
    .replace(/['’]/g, "")
    .replace(/[^a-z0-9]+/g, " ")
    .trim()
    .split(/\s+/)
    .slice(0, words)
    .join("-") || "entry";

export const uniqueId = (base, entries) => {
  const taken = new Set(entries.map((e) => e.id));
  let id = base;
  for (let n = 2; taken.has(id); n++) id = `${base}-${n}`;
  return id;
};
